module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative",
    attrs: {
      "id": "original-prompt"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 top-xs original-prompt-container feed-card readable-text relative",
    class: _vm.prompt_card_dynamic_classes,
    style: (_vm.dyanamic_styles),
    attrs: {
      "id": "prompt-card-in-feed"
    },
    on: {
      "click": function($event) {
        _vm.is_expanded = true
      }
    }
  }, [_c('walkthrough', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editPrompt),
      expression: "!editPrompt"
    }],
    staticClass: "walkthrough-position",
    attrs: {
      "componentName": "Prompt"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-prompt end-xs pl-caption"
  }, [_c('div', {
    staticClass: "relative flex justify-between items-center"
  }, [(!_vm.editPrompt) ? _c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "avatar-rounded avatar-size fr mr3"
  }, [(_vm.getRoundtableAuthor.email === _vm.getProfile.email) ? _c('img', {
    attrs: {
      "src": _vm.getProfile.avatar_url,
      "alt": "avatar"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.getRoundtableAuthor.avatar_url,
      "alt": "avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tl pl-caption mr3"
  }, [_c('p', {
    staticClass: "ma0"
  }, [_vm._v("Discussion prompt by:")]), _vm._v(" "), _c('p', {
    staticClass: "ma0 pl-title"
  }, [_vm._v("\n                " + _vm._s(_vm.getRoundtableAuthor.preferred_name ||
    _vm.getRoundtableAuthor.name) + "\n              ")])])])]) : _vm._e(), _vm._v(" "), (_vm.is_expanded && _vm.submission_cards_exist && !_vm.editPrompt) ? _c('pl-button', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: ('collapse'),
      expression: "'collapse'"
    }],
    key: "collapse",
    staticClass: "pl-icon no-margin",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.is_expanded = !_vm.is_expanded
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "15px"
    },
    attrs: {
      "src": "/static/minimize.svg",
      "alt": "collapse prompt"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && !_vm.editPrompt) ? _c('div', {
    staticClass: "flex-grow"
  }, [_c('pl-button', {
    staticClass: "edit-roundtable-button pl-charcoal-font",
    nativeOn: {
      "click": function($event) {
        return _vm.openEdit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("\n            Edit\n          ")])], 1) : _vm._e()], 1)]), _vm._v(" "), (!_vm.editPrompt) ? [_c('base', {
    attrs: {
      "target": "_blank"
    }
  }), _vm._v(" "), (_vm.getCurrentRT.prompt) ? _c('div', {
    staticClass: "start-xs"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_expanded || !_vm.submission_cards_exist),
      expression: "is_expanded || !submission_cards_exist"
    }],
    staticClass: "pl-body-1",
    domProps: {
      "innerHTML": _vm._s(_vm.prompt_adjusted_with_links)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_expanded && _vm.submission_cards_exist),
      expression: "!is_expanded && submission_cards_exist"
    }],
    staticClass: "ellipsis-text tl mt3"
  }, [_vm._v("\n          " + _vm._s(_vm.prompt_text_only) + "\n        ")])]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm.show_share_to_universe_modal) ? _c('share-to-universe-modal', {
    on: {
      "close": function($event) {
        _vm.show_share_to_universe_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-f27bdd30!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/pages/feed/promptInFeed.vue
// module id = 1367
// module chunks = 61